// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
const mc = require('__libs/ModuleConstructor.js');
mc.runVue(['Slider', 'Navigation','selectList']);
mc.runComponents(['rating']);
mc.runFooter();

$('body').on('ajaxResponse', function() {
	mc.runVue(['selectList']);
});



// WEBPACK FOOTER //
// ./entries/stock.js